module.exports={close:"Zamknij",error:"Błąd",info:"Informacja",success:"Powodzenie",warning:"Ostrzeżenie"};